import React, { useMemo, useRef, useState,useEffect } from "react";
import withRouter from "../../../components/Common/withRouter";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
  Badge,
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import { Link } from "react-router-dom";
import "react-quill/dist/quill.snow.css";

const ManageProduct = () => {
  document.title = "Products | Vekart";
  const baseurl = process.env.REACT_APP_BASE_URL;
  const imgurl = process.env.REACT_APP_IMAGE_URL;
  const [productsData, setproductsData] = useState([]);
  const [error, setError] = useState(null);
  
  const fetchproductsData = async () => {
        try {
          setError(null);
          const response = await fetch(`${baseurl}/admin/products/products`);
          if (!response.ok) throw new Error("Network response was not ok");
          const data = await response.json();
          setproductsData(data);
        } catch (error) {
          setError(error.message);
        }
      };
    
      useEffect(() => {
        fetchproductsData();
      }, []);


  const columns = useMemo(
    () => [
      {
        Header: "Product Code",
        accessor: "product_code",
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "Product Name",
        accessor: "product_name",
        filterable: true,
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "Brand Name",
        accessor: "brandname",
        filterable: true,
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "Qty",
        accessor: "reserved_quantity",
        filterable: true,
      },
      {
        Header: "MRP",
        accessor: "mrp",
        filterable: true,
      },
      {
        Header: "purchase_price",
        accessor: "purchase_price",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "status",
        filterable: true,
        Cell: ({ value }) => (
          <Badge color={value === "Active" ? "success" : "danger"}>
            {value.charAt(0).toUpperCase() + value.slice(1)}
          </Badge>
        ),
      },

      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => (
          <div className="d-flex gap-3">
            <Link
              to={`/manage-products/view-product/${row.original.product_code}`}
              className="text-success"
            >
              <i
                className="mdi mdi-eye-outline font-size-18"
                id="viewtooltip"
              ></i>
              <UncontrolledTooltip placement="top" target="viewtooltip">
                View
              </UncontrolledTooltip>
            </Link>
            <Link
              to={`/manage-products/edit-product/${row.original.product_code}`}
              className="text-success"
            >
              <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              <UncontrolledTooltip placement="top" target="edittooltip">
                Edit
              </UncontrolledTooltip>
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Product" breadcrumbItem="Manage Products" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={productsData}
                    isGlobalFilter={true}
                    customPageSize={10}
                    isAddProduct={true}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default withRouter(ManageProduct);
